/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkInputBody,
  BulkOutputBody,
  CreateInputBody2,
  CreateViewInputBody,
  ErrorModel,
  MarkReadInputBody,
  MarkReadOutputBody,
  RecordBody,
  RecordListBody,
  RecordsDiscardHeaders,
  RecordsListParams,
  RecordsPublishHeaders,
  RecordsRevertHeaders,
  RecordsSaveHeaders,
  RecordsViewUpdateHeaders,
  ReorderInputBody1,
  SaveInputBody,
  StageInputBody,
  StagesOutputBody,
  UpdateViewInputBody,
  VersionOutputBody,
  VersionsOutputBody,
  ViewBody,
  ViewsOutputBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type recordsListResponse200 = {
  data: RecordListBody
  status: 200
}

export type recordsListResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsListResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsListResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsListResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsListResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsListResponseSuccess = (recordsListResponse200) & {
  headers: Headers;
};
export type recordsListResponseError = (recordsListResponse401 | recordsListResponse403 | recordsListResponse404 | recordsListResponse422 | recordsListResponse500) & {
  headers: Headers;
};

export type recordsListResponse = (recordsListResponseSuccess | recordsListResponseError)

export const getRecordsListUrl = (typeId: string,
    params?: RecordsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/content-types/${typeId}/records?${stringifiedParams}` : `/content-types/${typeId}/records`
}

/**
 * Площадка обязательна: у боевой и у разработки одна форма, но разные записи, и список без указания площадки не имеет смысла.
 * @summary Записи типа на площадке
 */
export const recordsList = async (typeId: string,
    params?: RecordsListParams, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsListResponse> => {

  return facetaFetch<recordsListResponse>(getRecordsListUrl(typeId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRecordsListQueryKey = (typeId: string,
    params?: RecordsListParams,) => {
    return [
    `/content-types/${typeId}/records`, ...(params ? [params] : [])
    ] as const;
    }


export const getRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof recordsList>>, TError = ErrorModel>(typeId: string,
    params?: RecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsListQueryKey(typeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsList>>> = ({ signal }) => recordsList(typeId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof recordsList>>>
export type RecordsListQueryError = ErrorModel


export function useRecordsList<TData = Awaited<ReturnType<typeof recordsList>>, TError = ErrorModel>(
 typeId: string,
    params: undefined |  RecordsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsList>>,
          TError,
          Awaited<ReturnType<typeof recordsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsList<TData = Awaited<ReturnType<typeof recordsList>>, TError = ErrorModel>(
 typeId: string,
    params?: RecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsList>>,
          TError,
          Awaited<ReturnType<typeof recordsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsList<TData = Awaited<ReturnType<typeof recordsList>>, TError = ErrorModel>(
 typeId: string,
    params?: RecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Записи типа на площадке
 */

export function useRecordsList<TData = Awaited<ReturnType<typeof recordsList>>, TError = ErrorModel>(
 typeId: string,
    params?: RecordsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsList>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsListQueryOptions(typeId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsCreateResponse201 = {
  data: RecordBody
  status: 201
}

export type recordsCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsCreateResponse409 = {
  data: ErrorModel
  status: 409
}

export type recordsCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsCreateResponseSuccess = (recordsCreateResponse201) & {
  headers: Headers;
};
export type recordsCreateResponseError = (recordsCreateResponse401 | recordsCreateResponse403 | recordsCreateResponse404 | recordsCreateResponse409 | recordsCreateResponse422 | recordsCreateResponse500) & {
  headers: Headers;
};

export type recordsCreateResponse = (recordsCreateResponseSuccess | recordsCreateResponseError)

export const getRecordsCreateUrl = (typeId: string,) => {




  return `/content-types/${typeId}/records`
}

/**
 * Обязательные поля здесь не проверяются: запись заводят пустой и заполняют постепенно. Проверка — при публикации.
 * @summary Завести запись
 */
export const recordsCreate = async (typeId: string,
    createInputBody2: NonReadonly<CreateInputBody2>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsCreateResponse>(getRecordsCreateUrl(typeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInputBody2)
  }
);}





export const getRecordsCreateQueryKey = (typeId: string,
    createInputBody2?: NonReadonly<CreateInputBody2>,) => {
    return [
    'POST', `/content-types/${typeId}/records`, createInputBody2
    ] as const;
    }


export const getRecordsCreateQueryOptions = <TData = Awaited<ReturnType<typeof recordsCreate>>, TError = ErrorModel>(typeId: string,
    createInputBody2: NonReadonly<CreateInputBody2>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsCreateQueryKey(typeId,createInputBody2);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsCreate>>> = ({ signal }) => recordsCreate(typeId,createInputBody2, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsCreateQueryResult = NonNullable<Awaited<ReturnType<typeof recordsCreate>>>
export type RecordsCreateQueryError = ErrorModel


export function useRecordsCreate<TData = Awaited<ReturnType<typeof recordsCreate>>, TError = ErrorModel>(
 typeId: string,
    createInputBody2: NonReadonly<CreateInputBody2>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsCreate>>,
          TError,
          Awaited<ReturnType<typeof recordsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsCreate<TData = Awaited<ReturnType<typeof recordsCreate>>, TError = ErrorModel>(
 typeId: string,
    createInputBody2: NonReadonly<CreateInputBody2>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsCreate>>,
          TError,
          Awaited<ReturnType<typeof recordsCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsCreate<TData = Awaited<ReturnType<typeof recordsCreate>>, TError = ErrorModel>(
 typeId: string,
    createInputBody2: NonReadonly<CreateInputBody2>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Завести запись
 */

export function useRecordsCreate<TData = Awaited<ReturnType<typeof recordsCreate>>, TError = ErrorModel>(
 typeId: string,
    createInputBody2: NonReadonly<CreateInputBody2>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsCreateQueryOptions(typeId,createInputBody2,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsBulkResponse200 = {
  data: BulkOutputBody
  status: 200
}

export type recordsBulkResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsBulkResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsBulkResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsBulkResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsBulkResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsBulkResponseSuccess = (recordsBulkResponse200) & {
  headers: Headers;
};
export type recordsBulkResponseError = (recordsBulkResponse401 | recordsBulkResponse403 | recordsBulkResponse404 | recordsBulkResponse422 | recordsBulkResponse500) & {
  headers: Headers;
};

export type recordsBulkResponse = (recordsBulkResponseSuccess | recordsBulkResponseError)

export const getRecordsBulkUrl = (typeId: string,) => {




  return `/content-types/${typeId}/records/bulk`
}

/**
 * Опубликовать, снять с сайта, в корзину, вернуть — до 200 записей за раз. Каждая запись — отдельно: у одной не заполнено обязательное поле — она в списке отказов, остальные опубликованы. Каждая попадает в журнал.
 * @summary Одно действие над многими записями
 */
export const recordsBulk = async (typeId: string,
    bulkInputBody: NonReadonly<BulkInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsBulkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsBulkResponse>(getRecordsBulkUrl(typeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkInputBody)
  }
);}





export const getRecordsBulkQueryKey = (typeId: string,
    bulkInputBody?: NonReadonly<BulkInputBody>,) => {
    return [
    'POST', `/content-types/${typeId}/records/bulk`, bulkInputBody
    ] as const;
    }


export const getRecordsBulkQueryOptions = <TData = Awaited<ReturnType<typeof recordsBulk>>, TError = ErrorModel>(typeId: string,
    bulkInputBody: NonReadonly<BulkInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsBulk>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsBulkQueryKey(typeId,bulkInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsBulk>>> = ({ signal }) => recordsBulk(typeId,bulkInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsBulk>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsBulkQueryResult = NonNullable<Awaited<ReturnType<typeof recordsBulk>>>
export type RecordsBulkQueryError = ErrorModel


export function useRecordsBulk<TData = Awaited<ReturnType<typeof recordsBulk>>, TError = ErrorModel>(
 typeId: string,
    bulkInputBody: NonReadonly<BulkInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsBulk>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsBulk>>,
          TError,
          Awaited<ReturnType<typeof recordsBulk>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsBulk<TData = Awaited<ReturnType<typeof recordsBulk>>, TError = ErrorModel>(
 typeId: string,
    bulkInputBody: NonReadonly<BulkInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsBulk>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsBulk>>,
          TError,
          Awaited<ReturnType<typeof recordsBulk>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsBulk<TData = Awaited<ReturnType<typeof recordsBulk>>, TError = ErrorModel>(
 typeId: string,
    bulkInputBody: NonReadonly<BulkInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsBulk>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Одно действие над многими записями
 */

export function useRecordsBulk<TData = Awaited<ReturnType<typeof recordsBulk>>, TError = ErrorModel>(
 typeId: string,
    bulkInputBody: NonReadonly<BulkInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsBulk>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsBulkQueryOptions(typeId,bulkInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsReorderResponse204 = {
  data: void
  status: 204
}

export type recordsReorderResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsReorderResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsReorderResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsReorderResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsReorderResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsReorderResponseSuccess = (recordsReorderResponse204) & {
  headers: Headers;
};
export type recordsReorderResponseError = (recordsReorderResponse401 | recordsReorderResponse403 | recordsReorderResponse404 | recordsReorderResponse422 | recordsReorderResponse500) & {
  headers: Headers;
};

export type recordsReorderResponse = (recordsReorderResponseSuccess | recordsReorderResponseError)

export const getRecordsReorderUrl = (typeId: string,) => {




  return `/content-types/${typeId}/records/order`
}

/**
 * Перетаскивание в списке. Порядок сразу виден сайту, поэтому право — как у публикации.
 * @summary Ручной порядок записей
 */
export const recordsReorder = async (typeId: string,
    reorderInputBody1: NonReadonly<ReorderInputBody1>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsReorderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsReorderResponse>(getRecordsReorderUrl(typeId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderInputBody1)
  }
);}





export const getRecordsReorderQueryKey = (typeId: string,
    reorderInputBody1?: NonReadonly<ReorderInputBody1>,) => {
    return [
    'PUT', `/content-types/${typeId}/records/order`, reorderInputBody1
    ] as const;
    }


export const getRecordsReorderQueryOptions = <TData = Awaited<ReturnType<typeof recordsReorder>>, TError = ErrorModel>(typeId: string,
    reorderInputBody1: NonReadonly<ReorderInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsReorderQueryKey(typeId,reorderInputBody1);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsReorder>>> = ({ signal }) => recordsReorder(typeId,reorderInputBody1, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsReorder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsReorderQueryResult = NonNullable<Awaited<ReturnType<typeof recordsReorder>>>
export type RecordsReorderQueryError = ErrorModel


export function useRecordsReorder<TData = Awaited<ReturnType<typeof recordsReorder>>, TError = ErrorModel>(
 typeId: string,
    reorderInputBody1: NonReadonly<ReorderInputBody1>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsReorder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsReorder>>,
          TError,
          Awaited<ReturnType<typeof recordsReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsReorder<TData = Awaited<ReturnType<typeof recordsReorder>>, TError = ErrorModel>(
 typeId: string,
    reorderInputBody1: NonReadonly<ReorderInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsReorder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsReorder>>,
          TError,
          Awaited<ReturnType<typeof recordsReorder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsReorder<TData = Awaited<ReturnType<typeof recordsReorder>>, TError = ErrorModel>(
 typeId: string,
    reorderInputBody1: NonReadonly<ReorderInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ручной порядок записей
 */

export function useRecordsReorder<TData = Awaited<ReturnType<typeof recordsReorder>>, TError = ErrorModel>(
 typeId: string,
    reorderInputBody1: NonReadonly<ReorderInputBody1>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsReorder>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsReorderQueryOptions(typeId,reorderInputBody1,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsMarkReadResponse200 = {
  data: MarkReadOutputBody
  status: 200
}

export type recordsMarkReadResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsMarkReadResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsMarkReadResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsMarkReadResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsMarkReadResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsMarkReadResponseSuccess = (recordsMarkReadResponse200) & {
  headers: Headers;
};
export type recordsMarkReadResponseError = (recordsMarkReadResponse401 | recordsMarkReadResponse403 | recordsMarkReadResponse404 | recordsMarkReadResponse422 | recordsMarkReadResponse500) & {
  headers: Headers;
};

export type recordsMarkReadResponse = (recordsMarkReadResponseSuccess | recordsMarkReadResponseError)

export const getRecordsMarkReadUrl = (typeId: string,) => {




  return `/content-types/${typeId}/records/read`
}

/**
 * Заявки формы: прочитанные или снова новые — выбранные или все. Право — чтение: отметка общая для команды и содержимое не меняет.
 * @summary Отметить прочитанными
 */
export const recordsMarkRead = async (typeId: string,
    markReadInputBody: NonReadonly<MarkReadInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsMarkReadResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsMarkReadResponse>(getRecordsMarkReadUrl(typeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(markReadInputBody)
  }
);}





export const getRecordsMarkReadQueryKey = (typeId: string,
    markReadInputBody?: NonReadonly<MarkReadInputBody>,) => {
    return [
    'POST', `/content-types/${typeId}/records/read`, markReadInputBody
    ] as const;
    }


export const getRecordsMarkReadQueryOptions = <TData = Awaited<ReturnType<typeof recordsMarkRead>>, TError = ErrorModel>(typeId: string,
    markReadInputBody: NonReadonly<MarkReadInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsMarkRead>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsMarkReadQueryKey(typeId,markReadInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsMarkRead>>> = ({ signal }) => recordsMarkRead(typeId,markReadInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsMarkRead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsMarkReadQueryResult = NonNullable<Awaited<ReturnType<typeof recordsMarkRead>>>
export type RecordsMarkReadQueryError = ErrorModel


export function useRecordsMarkRead<TData = Awaited<ReturnType<typeof recordsMarkRead>>, TError = ErrorModel>(
 typeId: string,
    markReadInputBody: NonReadonly<MarkReadInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsMarkRead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsMarkRead>>,
          TError,
          Awaited<ReturnType<typeof recordsMarkRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsMarkRead<TData = Awaited<ReturnType<typeof recordsMarkRead>>, TError = ErrorModel>(
 typeId: string,
    markReadInputBody: NonReadonly<MarkReadInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsMarkRead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsMarkRead>>,
          TError,
          Awaited<ReturnType<typeof recordsMarkRead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsMarkRead<TData = Awaited<ReturnType<typeof recordsMarkRead>>, TError = ErrorModel>(
 typeId: string,
    markReadInputBody: NonReadonly<MarkReadInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsMarkRead>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отметить прочитанными
 */

export function useRecordsMarkRead<TData = Awaited<ReturnType<typeof recordsMarkRead>>, TError = ErrorModel>(
 typeId: string,
    markReadInputBody: NonReadonly<MarkReadInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsMarkRead>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsMarkReadQueryOptions(typeId,markReadInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsViewsResponse200 = {
  data: ViewsOutputBody
  status: 200
}

export type recordsViewsResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsViewsResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsViewsResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsViewsResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsViewsResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsViewsResponseSuccess = (recordsViewsResponse200) & {
  headers: Headers;
};
export type recordsViewsResponseError = (recordsViewsResponse401 | recordsViewsResponse403 | recordsViewsResponse404 | recordsViewsResponse422 | recordsViewsResponse500) & {
  headers: Headers;
};

export type recordsViewsResponse = (recordsViewsResponseSuccess | recordsViewsResponseError)

export const getRecordsViewsUrl = (typeId: string,) => {




  return `/content-types/${typeId}/views`
}

/**
 * Виды общие для всех, кто видит коллекцию: настроил один — пользуются все.
 * @summary Сохранённые виды коллекции
 */
export const recordsViews = async (typeId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsViewsResponse> => {

  return facetaFetch<recordsViewsResponse>(getRecordsViewsUrl(typeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRecordsViewsQueryKey = (typeId: string,) => {
    return [
    `/content-types/${typeId}/views`
    ] as const;
    }


export const getRecordsViewsQueryOptions = <TData = Awaited<ReturnType<typeof recordsViews>>, TError = ErrorModel>(typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViews>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsViewsQueryKey(typeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsViews>>> = ({ signal }) => recordsViews(typeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsViews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsViewsQueryResult = NonNullable<Awaited<ReturnType<typeof recordsViews>>>
export type RecordsViewsQueryError = ErrorModel


export function useRecordsViews<TData = Awaited<ReturnType<typeof recordsViews>>, TError = ErrorModel>(
 typeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsViews>>,
          TError,
          Awaited<ReturnType<typeof recordsViews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsViews<TData = Awaited<ReturnType<typeof recordsViews>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsViews>>,
          TError,
          Awaited<ReturnType<typeof recordsViews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsViews<TData = Awaited<ReturnType<typeof recordsViews>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViews>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сохранённые виды коллекции
 */

export function useRecordsViews<TData = Awaited<ReturnType<typeof recordsViews>>, TError = ErrorModel>(
 typeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViews>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsViewsQueryOptions(typeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsViewCreateResponse201 = {
  data: ViewBody
  status: 201
}

export type recordsViewCreateResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsViewCreateResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsViewCreateResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsViewCreateResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsViewCreateResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsViewCreateResponseSuccess = (recordsViewCreateResponse201) & {
  headers: Headers;
};
export type recordsViewCreateResponseError = (recordsViewCreateResponse401 | recordsViewCreateResponse403 | recordsViewCreateResponse404 | recordsViewCreateResponse422 | recordsViewCreateResponse500) & {
  headers: Headers;
};

export type recordsViewCreateResponse = (recordsViewCreateResponseSuccess | recordsViewCreateResponseError)

export const getRecordsViewCreateUrl = (typeId: string,) => {




  return `/content-types/${typeId}/views`
}

/**
 * @summary Сохранить вид
 */
export const recordsViewCreate = async (typeId: string,
    createViewInputBody: NonReadonly<CreateViewInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsViewCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsViewCreateResponse>(getRecordsViewCreateUrl(typeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createViewInputBody)
  }
);}





export const getRecordsViewCreateQueryKey = (typeId: string,
    createViewInputBody?: NonReadonly<CreateViewInputBody>,) => {
    return [
    'POST', `/content-types/${typeId}/views`, createViewInputBody
    ] as const;
    }


export const getRecordsViewCreateQueryOptions = <TData = Awaited<ReturnType<typeof recordsViewCreate>>, TError = ErrorModel>(typeId: string,
    createViewInputBody: NonReadonly<CreateViewInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsViewCreateQueryKey(typeId,createViewInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsViewCreate>>> = ({ signal }) => recordsViewCreate(typeId,createViewInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: typeId !== null && typeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsViewCreate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsViewCreateQueryResult = NonNullable<Awaited<ReturnType<typeof recordsViewCreate>>>
export type RecordsViewCreateQueryError = ErrorModel


export function useRecordsViewCreate<TData = Awaited<ReturnType<typeof recordsViewCreate>>, TError = ErrorModel>(
 typeId: string,
    createViewInputBody: NonReadonly<CreateViewInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewCreate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsViewCreate>>,
          TError,
          Awaited<ReturnType<typeof recordsViewCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsViewCreate<TData = Awaited<ReturnType<typeof recordsViewCreate>>, TError = ErrorModel>(
 typeId: string,
    createViewInputBody: NonReadonly<CreateViewInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewCreate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsViewCreate>>,
          TError,
          Awaited<ReturnType<typeof recordsViewCreate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsViewCreate<TData = Awaited<ReturnType<typeof recordsViewCreate>>, TError = ErrorModel>(
 typeId: string,
    createViewInputBody: NonReadonly<CreateViewInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сохранить вид
 */

export function useRecordsViewCreate<TData = Awaited<ReturnType<typeof recordsViewCreate>>, TError = ErrorModel>(
 typeId: string,
    createViewInputBody: NonReadonly<CreateViewInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewCreate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsViewCreateQueryOptions(typeId,createViewInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsDeleteResponse204 = {
  data: void
  status: 204
}

export type recordsDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsDeleteResponseSuccess = (recordsDeleteResponse204) & {
  headers: Headers;
};
export type recordsDeleteResponseError = (recordsDeleteResponse401 | recordsDeleteResponse403 | recordsDeleteResponse404 | recordsDeleteResponse422 | recordsDeleteResponse500) & {
  headers: Headers;
};

export type recordsDeleteResponse = (recordsDeleteResponseSuccess | recordsDeleteResponseError)

export const getRecordsDeleteUrl = (recordId: string,) => {




  return `/records/${recordId}`
}

/**
 * @summary Удалить запись
 */
export const recordsDelete = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsDeleteResponse> => {

  return facetaFetch<recordsDeleteResponse>(getRecordsDeleteUrl(recordId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRecordsDeleteQueryKey = (recordId: string,) => {
    return [
    'DELETE', `/records/${recordId}`
    ] as const;
    }


export const getRecordsDeleteQueryOptions = <TData = Awaited<ReturnType<typeof recordsDelete>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsDeleteQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsDelete>>> = ({ signal }) => recordsDelete(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof recordsDelete>>>
export type RecordsDeleteQueryError = ErrorModel


export function useRecordsDelete<TData = Awaited<ReturnType<typeof recordsDelete>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsDelete>>,
          TError,
          Awaited<ReturnType<typeof recordsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsDelete<TData = Awaited<ReturnType<typeof recordsDelete>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsDelete>>,
          TError,
          Awaited<ReturnType<typeof recordsDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsDelete<TData = Awaited<ReturnType<typeof recordsDelete>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить запись
 */

export function useRecordsDelete<TData = Awaited<ReturnType<typeof recordsDelete>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsDeleteQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsGetResponse200 = {
  data: RecordBody
  status: 200
}

export type recordsGetResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsGetResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsGetResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsGetResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsGetResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsGetResponseSuccess = (recordsGetResponse200) & {
  headers: Headers;
};
export type recordsGetResponseError = (recordsGetResponse401 | recordsGetResponse403 | recordsGetResponse404 | recordsGetResponse422 | recordsGetResponse500) & {
  headers: Headers;
};

export type recordsGetResponse = (recordsGetResponseSuccess | recordsGetResponseError)

export const getRecordsGetUrl = (recordId: string,) => {




  return `/records/${recordId}`
}

/**
 * @summary Запись
 */
export const recordsGet = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsGetResponse> => {

  return facetaFetch<recordsGetResponse>(getRecordsGetUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRecordsGetQueryKey = (recordId: string,) => {
    return [
    `/records/${recordId}`
    ] as const;
    }


export const getRecordsGetQueryOptions = <TData = Awaited<ReturnType<typeof recordsGet>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsGetQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsGet>>> = ({ signal }) => recordsGet(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsGetQueryResult = NonNullable<Awaited<ReturnType<typeof recordsGet>>>
export type RecordsGetQueryError = ErrorModel


export function useRecordsGet<TData = Awaited<ReturnType<typeof recordsGet>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsGet>>,
          TError,
          Awaited<ReturnType<typeof recordsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsGet<TData = Awaited<ReturnType<typeof recordsGet>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsGet>>,
          TError,
          Awaited<ReturnType<typeof recordsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsGet<TData = Awaited<ReturnType<typeof recordsGet>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Запись
 */

export function useRecordsGet<TData = Awaited<ReturnType<typeof recordsGet>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsGet>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsGetQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsSaveResponse200 = {
  data: RecordBody
  status: 200
}

export type recordsSaveResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsSaveResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsSaveResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsSaveResponse409 = {
  data: ErrorModel
  status: 409
}

export type recordsSaveResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsSaveResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsSaveResponseSuccess = (recordsSaveResponse200) & {
  headers: Headers;
};
export type recordsSaveResponseError = (recordsSaveResponse401 | recordsSaveResponse403 | recordsSaveResponse404 | recordsSaveResponse409 | recordsSaveResponse422 | recordsSaveResponse500) & {
  headers: Headers;
};

export type recordsSaveResponse = (recordsSaveResponseSuccess | recordsSaveResponseError)

export const getRecordsSaveUrl = (recordId: string,) => {




  return `/records/${recordId}`
}

/**
 * Каждое сохранение добавляет версию. Значения приходят целиком: частичное обновление сделало бы «очистить поле» неотличимым от «не трогать его».
 * @summary Сохранить черновик
 */
export const recordsSave = async (recordId: string,
    saveInputBody: NonReadonly<SaveInputBody>,
    headers: RecordsSaveHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsSaveResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsSaveResponse>(getRecordsSaveUrl(recordId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(saveInputBody)
  }
);}





export const getRecordsSaveQueryKey = (recordId: string,
    saveInputBody?: NonReadonly<SaveInputBody>,) => {
    return [
    'PATCH', `/records/${recordId}`, saveInputBody
    ] as const;
    }


export const getRecordsSaveQueryOptions = <TData = Awaited<ReturnType<typeof recordsSave>>, TError = ErrorModel>(recordId: string,
    saveInputBody: NonReadonly<SaveInputBody>,
    headers: RecordsSaveHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsSave>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsSaveQueryKey(recordId,saveInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsSave>>> = ({ signal }) => recordsSave(recordId,saveInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsSave>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsSaveQueryResult = NonNullable<Awaited<ReturnType<typeof recordsSave>>>
export type RecordsSaveQueryError = ErrorModel


export function useRecordsSave<TData = Awaited<ReturnType<typeof recordsSave>>, TError = ErrorModel>(
 recordId: string,
    saveInputBody: NonReadonly<SaveInputBody>,
    headers: RecordsSaveHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsSave>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsSave>>,
          TError,
          Awaited<ReturnType<typeof recordsSave>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsSave<TData = Awaited<ReturnType<typeof recordsSave>>, TError = ErrorModel>(
 recordId: string,
    saveInputBody: NonReadonly<SaveInputBody>,
    headers: RecordsSaveHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsSave>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsSave>>,
          TError,
          Awaited<ReturnType<typeof recordsSave>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsSave<TData = Awaited<ReturnType<typeof recordsSave>>, TError = ErrorModel>(
 recordId: string,
    saveInputBody: NonReadonly<SaveInputBody>,
    headers: RecordsSaveHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsSave>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сохранить черновик
 */

export function useRecordsSave<TData = Awaited<ReturnType<typeof recordsSave>>, TError = ErrorModel>(
 recordId: string,
    saveInputBody: NonReadonly<SaveInputBody>,
    headers: RecordsSaveHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsSave>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsSaveQueryOptions(recordId,saveInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsDiscardResponse200 = {
  data: RecordBody
  status: 200
}

export type recordsDiscardResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsDiscardResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsDiscardResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsDiscardResponse409 = {
  data: ErrorModel
  status: 409
}

export type recordsDiscardResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsDiscardResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsDiscardResponseSuccess = (recordsDiscardResponse200) & {
  headers: Headers;
};
export type recordsDiscardResponseError = (recordsDiscardResponse401 | recordsDiscardResponse403 | recordsDiscardResponse404 | recordsDiscardResponse409 | recordsDiscardResponse422 | recordsDiscardResponse500) & {
  headers: Headers;
};

export type recordsDiscardResponse = (recordsDiscardResponseSuccess | recordsDiscardResponseError)

export const getRecordsDiscardUrl = (recordId: string,) => {




  return `/records/${recordId}/discard`
}

/**
 * Черновик возвращается к тому, что сейчас на сайте. Отмена — новая версия: отменённые правки остаются в истории, и вернуть их можно. У неопубликованной записи отменять не к чему — 409.
 * @summary Отменить неопубликованные правки
 */
export const recordsDiscard = async (recordId: string,
    headers: RecordsDiscardHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsDiscardResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsDiscardResponse>(getRecordsDiscardUrl(recordId),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getRecordsDiscardQueryKey = (recordId: string,) => {
    return [
    'POST', `/records/${recordId}/discard`
    ] as const;
    }


export const getRecordsDiscardQueryOptions = <TData = Awaited<ReturnType<typeof recordsDiscard>>, TError = ErrorModel>(recordId: string,
    headers: RecordsDiscardHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDiscard>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsDiscardQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsDiscard>>> = ({ signal }) => recordsDiscard(recordId,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsDiscard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsDiscardQueryResult = NonNullable<Awaited<ReturnType<typeof recordsDiscard>>>
export type RecordsDiscardQueryError = ErrorModel


export function useRecordsDiscard<TData = Awaited<ReturnType<typeof recordsDiscard>>, TError = ErrorModel>(
 recordId: string,
    headers: RecordsDiscardHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDiscard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsDiscard>>,
          TError,
          Awaited<ReturnType<typeof recordsDiscard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsDiscard<TData = Awaited<ReturnType<typeof recordsDiscard>>, TError = ErrorModel>(
 recordId: string,
    headers: RecordsDiscardHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDiscard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsDiscard>>,
          TError,
          Awaited<ReturnType<typeof recordsDiscard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsDiscard<TData = Awaited<ReturnType<typeof recordsDiscard>>, TError = ErrorModel>(
 recordId: string,
    headers: RecordsDiscardHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDiscard>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отменить неопубликованные правки
 */

export function useRecordsDiscard<TData = Awaited<ReturnType<typeof recordsDiscard>>, TError = ErrorModel>(
 recordId: string,
    headers: RecordsDiscardHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsDiscard>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsDiscardQueryOptions(recordId,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsPublishResponse200 = {
  data: RecordBody
  status: 200
}

export type recordsPublishResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsPublishResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsPublishResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsPublishResponse409 = {
  data: ErrorModel
  status: 409
}

export type recordsPublishResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsPublishResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsPublishResponseSuccess = (recordsPublishResponse200) & {
  headers: Headers;
};
export type recordsPublishResponseError = (recordsPublishResponse401 | recordsPublishResponse403 | recordsPublishResponse404 | recordsPublishResponse409 | recordsPublishResponse422 | recordsPublishResponse500) & {
  headers: Headers;
};

export type recordsPublishResponse = (recordsPublishResponseSuccess | recordsPublishResponseError)

export const getRecordsPublishUrl = (recordId: string,) => {




  return `/records/${recordId}/publish`
}

/**
 * Снимает копию черновика — именно её отдаёт сайт. Следующая правка на сайт сама не уедет. Здесь же проверяются обязательные поля: незаполненное уедет на сайт дырой.
 * @summary Опубликовать
 */
export const recordsPublish = async (recordId: string,
    headers: RecordsPublishHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsPublishResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsPublishResponse>(getRecordsPublishUrl(recordId),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getRecordsPublishQueryKey = (recordId: string,) => {
    return [
    'POST', `/records/${recordId}/publish`
    ] as const;
    }


export const getRecordsPublishQueryOptions = <TData = Awaited<ReturnType<typeof recordsPublish>>, TError = ErrorModel>(recordId: string,
    headers: RecordsPublishHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsPublish>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsPublishQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsPublish>>> = ({ signal }) => recordsPublish(recordId,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsPublish>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsPublishQueryResult = NonNullable<Awaited<ReturnType<typeof recordsPublish>>>
export type RecordsPublishQueryError = ErrorModel


export function useRecordsPublish<TData = Awaited<ReturnType<typeof recordsPublish>>, TError = ErrorModel>(
 recordId: string,
    headers: RecordsPublishHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsPublish>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsPublish>>,
          TError,
          Awaited<ReturnType<typeof recordsPublish>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsPublish<TData = Awaited<ReturnType<typeof recordsPublish>>, TError = ErrorModel>(
 recordId: string,
    headers: RecordsPublishHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsPublish>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsPublish>>,
          TError,
          Awaited<ReturnType<typeof recordsPublish>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsPublish<TData = Awaited<ReturnType<typeof recordsPublish>>, TError = ErrorModel>(
 recordId: string,
    headers: RecordsPublishHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsPublish>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Опубликовать
 */

export function useRecordsPublish<TData = Awaited<ReturnType<typeof recordsPublish>>, TError = ErrorModel>(
 recordId: string,
    headers: RecordsPublishHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsPublish>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsPublishQueryOptions(recordId,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsRestoreResponse200 = {
  data: RecordBody
  status: 200
}

export type recordsRestoreResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsRestoreResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsRestoreResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsRestoreResponse409 = {
  data: ErrorModel
  status: 409
}

export type recordsRestoreResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsRestoreResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsRestoreResponseSuccess = (recordsRestoreResponse200) & {
  headers: Headers;
};
export type recordsRestoreResponseError = (recordsRestoreResponse401 | recordsRestoreResponse403 | recordsRestoreResponse404 | recordsRestoreResponse409 | recordsRestoreResponse422 | recordsRestoreResponse500) & {
  headers: Headers;
};

export type recordsRestoreResponse = (recordsRestoreResponseSuccess | recordsRestoreResponseError)

export const getRecordsRestoreUrl = (recordId: string,) => {




  return `/records/${recordId}/restore`
}

/**
 * @summary Восстановить запись
 */
export const recordsRestore = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsRestoreResponse> => {

  return facetaFetch<recordsRestoreResponse>(getRecordsRestoreUrl(recordId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecordsRestoreQueryKey = (recordId: string,) => {
    return [
    'POST', `/records/${recordId}/restore`
    ] as const;
    }


export const getRecordsRestoreQueryOptions = <TData = Awaited<ReturnType<typeof recordsRestore>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsRestoreQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsRestore>>> = ({ signal }) => recordsRestore(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsRestore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsRestoreQueryResult = NonNullable<Awaited<ReturnType<typeof recordsRestore>>>
export type RecordsRestoreQueryError = ErrorModel


export function useRecordsRestore<TData = Awaited<ReturnType<typeof recordsRestore>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRestore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsRestore>>,
          TError,
          Awaited<ReturnType<typeof recordsRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsRestore<TData = Awaited<ReturnType<typeof recordsRestore>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRestore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsRestore>>,
          TError,
          Awaited<ReturnType<typeof recordsRestore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsRestore<TData = Awaited<ReturnType<typeof recordsRestore>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Восстановить запись
 */

export function useRecordsRestore<TData = Awaited<ReturnType<typeof recordsRestore>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRestore>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsRestoreQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsStageResponse200 = {
  data: RecordBody
  status: 200
}

export type recordsStageResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsStageResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsStageResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsStageResponse409 = {
  data: ErrorModel
  status: 409
}

export type recordsStageResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsStageResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsStageResponseSuccess = (recordsStageResponse200) & {
  headers: Headers;
};
export type recordsStageResponseError = (recordsStageResponse401 | recordsStageResponse403 | recordsStageResponse404 | recordsStageResponse409 | recordsStageResponse422 | recordsStageResponse500) & {
  headers: Headers;
};

export type recordsStageResponse = (recordsStageResponseSuccess | recordsStageResponseError)

export const getRecordsStageUrl = (recordId: string,) => {




  return `/records/${recordId}/stage`
}

/**
 * Только по разрешённому переходу из нынешнего статуса и только ролям перехода. Статус уже сменил кто-то другой — 409. Содержимое и публикацию не трогает.
 * @summary Сменить статус записи
 */
export const recordsStage = async (recordId: string,
    stageInputBody: NonReadonly<StageInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsStageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsStageResponse>(getRecordsStageUrl(recordId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stageInputBody)
  }
);}





export const getRecordsStageQueryKey = (recordId: string,
    stageInputBody?: NonReadonly<StageInputBody>,) => {
    return [
    'POST', `/records/${recordId}/stage`, stageInputBody
    ] as const;
    }


export const getRecordsStageQueryOptions = <TData = Awaited<ReturnType<typeof recordsStage>>, TError = ErrorModel>(recordId: string,
    stageInputBody: NonReadonly<StageInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsStageQueryKey(recordId,stageInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsStage>>> = ({ signal }) => recordsStage(recordId,stageInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsStage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsStageQueryResult = NonNullable<Awaited<ReturnType<typeof recordsStage>>>
export type RecordsStageQueryError = ErrorModel


export function useRecordsStage<TData = Awaited<ReturnType<typeof recordsStage>>, TError = ErrorModel>(
 recordId: string,
    stageInputBody: NonReadonly<StageInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsStage>>,
          TError,
          Awaited<ReturnType<typeof recordsStage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsStage<TData = Awaited<ReturnType<typeof recordsStage>>, TError = ErrorModel>(
 recordId: string,
    stageInputBody: NonReadonly<StageInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsStage>>,
          TError,
          Awaited<ReturnType<typeof recordsStage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsStage<TData = Awaited<ReturnType<typeof recordsStage>>, TError = ErrorModel>(
 recordId: string,
    stageInputBody: NonReadonly<StageInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сменить статус записи
 */

export function useRecordsStage<TData = Awaited<ReturnType<typeof recordsStage>>, TError = ErrorModel>(
 recordId: string,
    stageInputBody: NonReadonly<StageInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStage>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsStageQueryOptions(recordId,stageInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsStagesResponse200 = {
  data: StagesOutputBody
  status: 200
}

export type recordsStagesResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsStagesResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsStagesResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsStagesResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsStagesResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsStagesResponseSuccess = (recordsStagesResponse200) & {
  headers: Headers;
};
export type recordsStagesResponseError = (recordsStagesResponse401 | recordsStagesResponse403 | recordsStagesResponse404 | recordsStagesResponse422 | recordsStagesResponse500) & {
  headers: Headers;
};

export type recordsStagesResponse = (recordsStagesResponseSuccess | recordsStagesResponseError)

export const getRecordsStagesUrl = (recordId: string,) => {




  return `/records/${recordId}/stages`
}

/**
 * @summary История статусов записи
 */
export const recordsStages = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsStagesResponse> => {

  return facetaFetch<recordsStagesResponse>(getRecordsStagesUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRecordsStagesQueryKey = (recordId: string,) => {
    return [
    `/records/${recordId}/stages`
    ] as const;
    }


export const getRecordsStagesQueryOptions = <TData = Awaited<ReturnType<typeof recordsStages>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStages>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsStagesQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsStages>>> = ({ signal }) => recordsStages(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsStages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsStagesQueryResult = NonNullable<Awaited<ReturnType<typeof recordsStages>>>
export type RecordsStagesQueryError = ErrorModel


export function useRecordsStages<TData = Awaited<ReturnType<typeof recordsStages>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsStages>>,
          TError,
          Awaited<ReturnType<typeof recordsStages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsStages<TData = Awaited<ReturnType<typeof recordsStages>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsStages>>,
          TError,
          Awaited<ReturnType<typeof recordsStages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsStages<TData = Awaited<ReturnType<typeof recordsStages>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStages>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary История статусов записи
 */

export function useRecordsStages<TData = Awaited<ReturnType<typeof recordsStages>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsStages>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsStagesQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsUnpublishResponse200 = {
  data: RecordBody
  status: 200
}

export type recordsUnpublishResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsUnpublishResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsUnpublishResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsUnpublishResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsUnpublishResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsUnpublishResponseSuccess = (recordsUnpublishResponse200) & {
  headers: Headers;
};
export type recordsUnpublishResponseError = (recordsUnpublishResponse401 | recordsUnpublishResponse403 | recordsUnpublishResponse404 | recordsUnpublishResponse422 | recordsUnpublishResponse500) & {
  headers: Headers;
};

export type recordsUnpublishResponse = (recordsUnpublishResponseSuccess | recordsUnpublishResponseError)

export const getRecordsUnpublishUrl = (recordId: string,) => {




  return `/records/${recordId}/unpublish`
}

/**
 * Черновик остаётся: снятие с публикации — не удаление.
 * @summary Убрать с сайта
 */
export const recordsUnpublish = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsUnpublishResponse> => {

  return facetaFetch<recordsUnpublishResponse>(getRecordsUnpublishUrl(recordId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRecordsUnpublishQueryKey = (recordId: string,) => {
    return [
    'POST', `/records/${recordId}/unpublish`
    ] as const;
    }


export const getRecordsUnpublishQueryOptions = <TData = Awaited<ReturnType<typeof recordsUnpublish>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsUnpublish>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsUnpublishQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsUnpublish>>> = ({ signal }) => recordsUnpublish(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsUnpublish>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsUnpublishQueryResult = NonNullable<Awaited<ReturnType<typeof recordsUnpublish>>>
export type RecordsUnpublishQueryError = ErrorModel


export function useRecordsUnpublish<TData = Awaited<ReturnType<typeof recordsUnpublish>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsUnpublish>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsUnpublish>>,
          TError,
          Awaited<ReturnType<typeof recordsUnpublish>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsUnpublish<TData = Awaited<ReturnType<typeof recordsUnpublish>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsUnpublish>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsUnpublish>>,
          TError,
          Awaited<ReturnType<typeof recordsUnpublish>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsUnpublish<TData = Awaited<ReturnType<typeof recordsUnpublish>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsUnpublish>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Убрать с сайта
 */

export function useRecordsUnpublish<TData = Awaited<ReturnType<typeof recordsUnpublish>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsUnpublish>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsUnpublishQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsVersionsResponse200 = {
  data: VersionsOutputBody
  status: 200
}

export type recordsVersionsResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsVersionsResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsVersionsResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsVersionsResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsVersionsResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsVersionsResponseSuccess = (recordsVersionsResponse200) & {
  headers: Headers;
};
export type recordsVersionsResponseError = (recordsVersionsResponse401 | recordsVersionsResponse403 | recordsVersionsResponse404 | recordsVersionsResponse422 | recordsVersionsResponse500) & {
  headers: Headers;
};

export type recordsVersionsResponse = (recordsVersionsResponseSuccess | recordsVersionsResponseError)

export const getRecordsVersionsUrl = (recordId: string,) => {




  return `/records/${recordId}/versions`
}

/**
 * Каждое сохранение — версия. Значения версий не отдаются списком: история бывает длинной, а нужна из неё одна.
 * @summary История записи
 */
export const recordsVersions = async (recordId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsVersionsResponse> => {

  return facetaFetch<recordsVersionsResponse>(getRecordsVersionsUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRecordsVersionsQueryKey = (recordId: string,) => {
    return [
    `/records/${recordId}/versions`
    ] as const;
    }


export const getRecordsVersionsQueryOptions = <TData = Awaited<ReturnType<typeof recordsVersions>>, TError = ErrorModel>(recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersions>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsVersionsQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsVersions>>> = ({ signal }) => recordsVersions(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof recordsVersions>>>
export type RecordsVersionsQueryError = ErrorModel


export function useRecordsVersions<TData = Awaited<ReturnType<typeof recordsVersions>>, TError = ErrorModel>(
 recordId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsVersions>>,
          TError,
          Awaited<ReturnType<typeof recordsVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsVersions<TData = Awaited<ReturnType<typeof recordsVersions>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsVersions>>,
          TError,
          Awaited<ReturnType<typeof recordsVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsVersions<TData = Awaited<ReturnType<typeof recordsVersions>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersions>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary История записи
 */

export function useRecordsVersions<TData = Awaited<ReturnType<typeof recordsVersions>>, TError = ErrorModel>(
 recordId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersions>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsVersionsQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsVersionResponse200 = {
  data: VersionOutputBody
  status: 200
}

export type recordsVersionResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsVersionResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsVersionResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsVersionResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsVersionResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsVersionResponseSuccess = (recordsVersionResponse200) & {
  headers: Headers;
};
export type recordsVersionResponseError = (recordsVersionResponse401 | recordsVersionResponse403 | recordsVersionResponse404 | recordsVersionResponse422 | recordsVersionResponse500) & {
  headers: Headers;
};

export type recordsVersionResponse = (recordsVersionResponseSuccess | recordsVersionResponseError)

export const getRecordsVersionUrl = (recordId: string,
    versionId: string,) => {




  return `/records/${recordId}/versions/${versionId}`
}

/**
 * Для сравнения версии с текущим черновиком до того, как к ней возвращаться.
 * @summary Версия записи со значениями
 */
export const recordsVersion = async (recordId: string,
    versionId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsVersionResponse> => {

  return facetaFetch<recordsVersionResponse>(getRecordsVersionUrl(recordId,versionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRecordsVersionQueryKey = (recordId: string,
    versionId: string,) => {
    return [
    `/records/${recordId}/versions/${versionId}`
    ] as const;
    }


export const getRecordsVersionQueryOptions = <TData = Awaited<ReturnType<typeof recordsVersion>>, TError = ErrorModel>(recordId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersion>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsVersionQueryKey(recordId,versionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsVersion>>> = ({ signal }) => recordsVersion(recordId,versionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined && versionId !== null && versionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsVersionQueryResult = NonNullable<Awaited<ReturnType<typeof recordsVersion>>>
export type RecordsVersionQueryError = ErrorModel


export function useRecordsVersion<TData = Awaited<ReturnType<typeof recordsVersion>>, TError = ErrorModel>(
 recordId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsVersion>>,
          TError,
          Awaited<ReturnType<typeof recordsVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsVersion<TData = Awaited<ReturnType<typeof recordsVersion>>, TError = ErrorModel>(
 recordId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsVersion>>,
          TError,
          Awaited<ReturnType<typeof recordsVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsVersion<TData = Awaited<ReturnType<typeof recordsVersion>>, TError = ErrorModel>(
 recordId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersion>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Версия записи со значениями
 */

export function useRecordsVersion<TData = Awaited<ReturnType<typeof recordsVersion>>, TError = ErrorModel>(
 recordId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsVersion>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsVersionQueryOptions(recordId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsRevertResponse200 = {
  data: RecordBody
  status: 200
}

export type recordsRevertResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsRevertResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsRevertResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsRevertResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsRevertResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsRevertResponseSuccess = (recordsRevertResponse200) & {
  headers: Headers;
};
export type recordsRevertResponseError = (recordsRevertResponse401 | recordsRevertResponse403 | recordsRevertResponse404 | recordsRevertResponse422 | recordsRevertResponse500) & {
  headers: Headers;
};

export type recordsRevertResponse = (recordsRevertResponseSuccess | recordsRevertResponseError)

export const getRecordsRevertUrl = (recordId: string,
    versionId: string,) => {




  return `/records/${recordId}/versions/${versionId}/restore`
}

/**
 * Старая версия не восстанавливается на место, а копируется в черновик новой версией. История от возврата не теряется — иначе отменить сам возврат было бы нечем.
 * @summary Вернуть значения версии
 */
export const recordsRevert = async (recordId: string,
    versionId: string,
    headers: RecordsRevertHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsRevertResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsRevertResponse>(getRecordsRevertUrl(recordId,versionId),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getRecordsRevertQueryKey = (recordId: string,
    versionId: string,) => {
    return [
    'POST', `/records/${recordId}/versions/${versionId}/restore`
    ] as const;
    }


export const getRecordsRevertQueryOptions = <TData = Awaited<ReturnType<typeof recordsRevert>>, TError = ErrorModel>(recordId: string,
    versionId: string,
    headers: RecordsRevertHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRevert>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsRevertQueryKey(recordId,versionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsRevert>>> = ({ signal }) => recordsRevert(recordId,versionId,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined && versionId !== null && versionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsRevert>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsRevertQueryResult = NonNullable<Awaited<ReturnType<typeof recordsRevert>>>
export type RecordsRevertQueryError = ErrorModel


export function useRecordsRevert<TData = Awaited<ReturnType<typeof recordsRevert>>, TError = ErrorModel>(
 recordId: string,
    versionId: string,
    headers: RecordsRevertHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRevert>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsRevert>>,
          TError,
          Awaited<ReturnType<typeof recordsRevert>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsRevert<TData = Awaited<ReturnType<typeof recordsRevert>>, TError = ErrorModel>(
 recordId: string,
    versionId: string,
    headers: RecordsRevertHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRevert>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsRevert>>,
          TError,
          Awaited<ReturnType<typeof recordsRevert>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsRevert<TData = Awaited<ReturnType<typeof recordsRevert>>, TError = ErrorModel>(
 recordId: string,
    versionId: string,
    headers: RecordsRevertHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRevert>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вернуть значения версии
 */

export function useRecordsRevert<TData = Awaited<ReturnType<typeof recordsRevert>>, TError = ErrorModel>(
 recordId: string,
    versionId: string,
    headers: RecordsRevertHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsRevert>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsRevertQueryOptions(recordId,versionId,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsViewDeleteResponse204 = {
  data: void
  status: 204
}

export type recordsViewDeleteResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsViewDeleteResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsViewDeleteResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsViewDeleteResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsViewDeleteResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsViewDeleteResponseSuccess = (recordsViewDeleteResponse204) & {
  headers: Headers;
};
export type recordsViewDeleteResponseError = (recordsViewDeleteResponse401 | recordsViewDeleteResponse403 | recordsViewDeleteResponse404 | recordsViewDeleteResponse422 | recordsViewDeleteResponse500) & {
  headers: Headers;
};

export type recordsViewDeleteResponse = (recordsViewDeleteResponseSuccess | recordsViewDeleteResponseError)

export const getRecordsViewDeleteUrl = (viewId: string,) => {




  return `/views/${viewId}`
}

/**
 * Вид — настройка показа, а не данные: записи не трогаются, корзины нет.
 * @summary Удалить вид
 */
export const recordsViewDelete = async (viewId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsViewDeleteResponse> => {

  return facetaFetch<recordsViewDeleteResponse>(getRecordsViewDeleteUrl(viewId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRecordsViewDeleteQueryKey = (viewId: string,) => {
    return [
    'DELETE', `/views/${viewId}`
    ] as const;
    }


export const getRecordsViewDeleteQueryOptions = <TData = Awaited<ReturnType<typeof recordsViewDelete>>, TError = ErrorModel>(viewId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsViewDeleteQueryKey(viewId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsViewDelete>>> = ({ signal }) => recordsViewDelete(viewId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: viewId !== null && viewId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsViewDelete>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsViewDeleteQueryResult = NonNullable<Awaited<ReturnType<typeof recordsViewDelete>>>
export type RecordsViewDeleteQueryError = ErrorModel


export function useRecordsViewDelete<TData = Awaited<ReturnType<typeof recordsViewDelete>>, TError = ErrorModel>(
 viewId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewDelete>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsViewDelete>>,
          TError,
          Awaited<ReturnType<typeof recordsViewDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsViewDelete<TData = Awaited<ReturnType<typeof recordsViewDelete>>, TError = ErrorModel>(
 viewId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewDelete>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsViewDelete>>,
          TError,
          Awaited<ReturnType<typeof recordsViewDelete>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsViewDelete<TData = Awaited<ReturnType<typeof recordsViewDelete>>, TError = ErrorModel>(
 viewId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Удалить вид
 */

export function useRecordsViewDelete<TData = Awaited<ReturnType<typeof recordsViewDelete>>, TError = ErrorModel>(
 viewId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewDelete>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsViewDeleteQueryOptions(viewId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type recordsViewUpdateResponse200 = {
  data: ViewBody
  status: 200
}

export type recordsViewUpdateResponse401 = {
  data: ErrorModel
  status: 401
}

export type recordsViewUpdateResponse403 = {
  data: ErrorModel
  status: 403
}

export type recordsViewUpdateResponse404 = {
  data: ErrorModel
  status: 404
}

export type recordsViewUpdateResponse422 = {
  data: ErrorModel
  status: 422
}

export type recordsViewUpdateResponse500 = {
  data: ErrorModel
  status: 500
}

export type recordsViewUpdateResponseSuccess = (recordsViewUpdateResponse200) & {
  headers: Headers;
};
export type recordsViewUpdateResponseError = (recordsViewUpdateResponse401 | recordsViewUpdateResponse403 | recordsViewUpdateResponse404 | recordsViewUpdateResponse422 | recordsViewUpdateResponse500) & {
  headers: Headers;
};

export type recordsViewUpdateResponse = (recordsViewUpdateResponseSuccess | recordsViewUpdateResponseError)

export const getRecordsViewUpdateUrl = (viewId: string,) => {




  return `/views/${viewId}`
}

/**
 * @summary Поправить вид
 */
export const recordsViewUpdate = async (viewId: string,
    updateViewInputBody: NonReadonly<UpdateViewInputBody>,
    headers: RecordsViewUpdateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<recordsViewUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<recordsViewUpdateResponse>(getRecordsViewUpdateUrl(viewId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(updateViewInputBody)
  }
);}





export const getRecordsViewUpdateQueryKey = (viewId: string,
    updateViewInputBody?: NonReadonly<UpdateViewInputBody>,) => {
    return [
    'PATCH', `/views/${viewId}`, updateViewInputBody
    ] as const;
    }


export const getRecordsViewUpdateQueryOptions = <TData = Awaited<ReturnType<typeof recordsViewUpdate>>, TError = ErrorModel>(viewId: string,
    updateViewInputBody: NonReadonly<UpdateViewInputBody>,
    headers: RecordsViewUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRecordsViewUpdateQueryKey(viewId,updateViewInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof recordsViewUpdate>>> = ({ signal }) => recordsViewUpdate(viewId,updateViewInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: viewId !== null && viewId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof recordsViewUpdate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RecordsViewUpdateQueryResult = NonNullable<Awaited<ReturnType<typeof recordsViewUpdate>>>
export type RecordsViewUpdateQueryError = ErrorModel


export function useRecordsViewUpdate<TData = Awaited<ReturnType<typeof recordsViewUpdate>>, TError = ErrorModel>(
 viewId: string,
    updateViewInputBody: NonReadonly<UpdateViewInputBody>,
    headers: RecordsViewUpdateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewUpdate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsViewUpdate>>,
          TError,
          Awaited<ReturnType<typeof recordsViewUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsViewUpdate<TData = Awaited<ReturnType<typeof recordsViewUpdate>>, TError = ErrorModel>(
 viewId: string,
    updateViewInputBody: NonReadonly<UpdateViewInputBody>,
    headers: RecordsViewUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewUpdate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof recordsViewUpdate>>,
          TError,
          Awaited<ReturnType<typeof recordsViewUpdate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRecordsViewUpdate<TData = Awaited<ReturnType<typeof recordsViewUpdate>>, TError = ErrorModel>(
 viewId: string,
    updateViewInputBody: NonReadonly<UpdateViewInputBody>,
    headers: RecordsViewUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Поправить вид
 */

export function useRecordsViewUpdate<TData = Awaited<ReturnType<typeof recordsViewUpdate>>, TError = ErrorModel>(
 viewId: string,
    updateViewInputBody: NonReadonly<UpdateViewInputBody>,
    headers: RecordsViewUpdateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recordsViewUpdate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRecordsViewUpdateQueryOptions(viewId,updateViewInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






